export default __webpack_public_path__ + "static/media/priority_goals.238ef4a0.png";